import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const Nodiv = ({title}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 2,
                border: "1px dashed",
                borderColor: "grey.300",
                borderRadius: 2,
                bgcolor: "grey.50",
            }}
        >
            <InfoOutlinedIcon color="action" sx={{ fontSize: 30, mb: 1 }} />
            <Typography color="text.secondary">
                {title}
            </Typography>
        </Box>
    )
}

